import $ from 'jquery';
import CONSTANT from '../../common/js/_constant';

const articleOverView = {
    methods : {
        handleDate : (el)=>{
            // An article can carry more than one date (published, modified),
            // so format each node on its own: reading .text() off the whole
            // set would concatenate them into an unparsable string.
            $(el).find('.article-overview__date-text').each((idx, dateText)=>{
                let comingDate = $(dateText).text().trim();
                let comingDateObject = new Date(comingDate);
                if (!comingDate || isNaN(comingDateObject.getTime())) {
                    return;
                }
                $(dateText).text(comingDateObject.toLocaleDateString('en-US', {month: 'long'}) + " " + comingDateObject.getDate() + ", " + comingDateObject.getFullYear());
            });
        },
        handleShare :(el)=>{
            const shareLink = $(el).find('.article-overview__meta-item-share');
            $(shareLink).on('click',async (e) => {
                e.preventDefault();
                if (navigator.share) {
                    try {
                        await navigator.share({
                            url: window.location.href,
                        });
                    } catch (error) {
                        console.log('Error sharing:', error);
                    }
                } else {
                    alert('Web Share API is not supported in your Browser.');
                }
            });
        },
        init : ()=>{
            $('.article-overview').each((idx,ele)=>{
                articleOverView.methods.handleDate(ele);
                articleOverView.methods.handleShare(ele);
            });
        },
        blogShareButtonClickHandler: function(){
              $('.article-overview__meta-item-share').on('click', function() {
                let buttonText = $(this).text();
                let obj = articleOverView.methods.dataLayerObj(buttonText);
                 createDataLayer('buttonClick',obj);
              });
         },
                dataLayerObj: function (e) {
                          var obj = {
                            'articleName': "",
                            'blogCategory': "",
                            'blogPageCategory': "",
                            'buttonText': e ? e.replace(/\n/g, '').trim(): "share",
                            'pageSection': "",
                            'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? meetOurLeaders.variable.url.includes("blog") ? "Blogs" : meetOurLeaders.variable.url.substring(meetOurLeaders.variable.url.indexOf(".com/"), meetOurLeaders.variable.url.lastIndexOf('/')  === ".com") && !meetOurLeaders.variable.url.substring(meetOurLeaders.variable.url.indexOf(".com/"), meetOurLeaders.variable.url.length-1).includes('/') ? "Home" : "Other Pages" : "Blog Details Page",
                            'planOption': "",
                            'productCategory': "",
                            'productName': "",
                            'question': "",
                            'source': "",
                            'searchTerm': "",
                            'videoTitle': "",
                            'bannerName': "",
                          };
                          return obj;
                        },
    },
};

$(()=>{
    if($('.article-overview').length){
    articleOverView.methods.blogShareButtonClickHandler();
        articleOverView.methods.init();
    }
});
